export default function Updater(): null {
  return null
}
